export default {
  title: 'Lojas',
  icon: 'building',
  iconPack: 'bootstrap',
  children: [
    {
      title: 'Gestão de Empresas',
      route: 'company-list',
      resource: 'Company',
      action: 'Read',
    },
    {
      title: 'Gestão de Lojas',
      route: 'store-list',
      resource: 'Store',
      action: 'Read',
    },
    {
      title: 'Configuração de Delivery',
      route: 'delivery-config-list',
      resource: 'Store',
      action: 'ViewDeliveryConfig',
    },
    {
      title: 'Horários de Funcionamento',
      route: 'opening-hours-list',
      resource: 'Store',
      action: 'ViewOpeningHours',
    },
  ],
}
